export function Marquee({ items, className = "" }) {
  const content = [...items, ...items];
  return (
    <div className={`relative w-full overflow-hidden ${className}`} data-testid="marquee">
      <div className="marquee-track">
        {content.map((it, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 text-2xl sm:text-4xl font-serif font-light text-white/30">
            {it}
            <span className="text-gold text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
